import { forwardRef, ReactNode, useId } from "react";
import Icon from "../Icon";

type CheckboxProps = {
  className?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  name?: string;
  label: string | ReactNode;
  description?: string;
  required?: boolean;
  setValue?: (val: string) => void;
};

type Ref = HTMLInputElement;
type AllProps = React.ComponentPropsWithoutRef<"input"> & CheckboxProps;

const Checkbox = forwardRef<Ref, AllProps>(function (
  { description, checked, value, onChange, label, name, className, required, setValue, ...props },
  ref
) {
  const id = useId();

  return (
    <div className="grid  ">
      <label htmlFor={id} className="flex gap-2 items-baseline ">
        <div
          className={`relative  flex justify-center items-center aspect-square   w-1.5em h-1.5em

            `}
        >
          <input
            type="checkbox"
            value={value}
            checked={checked}
            ref={ref}
            onChange={(e) => {
              setValue?.(e.target.value);
              onChange?.(e);
            }}
            name={name}
            id={id}
            className={`sr-only `}
            aria-describedby={description && `${id}-description`}
            {...props}
          />
          <span className="text-sm c-white   opacity-0 [:checked+&]:opacity-100 transition-opacity duration-100 ease flex items-center justify-center pt-0.1em leading-1em">
            <Icon name="bf-i-ph-check-bold" subdued={false} className="" />
          </span>
          <div
            className={`absolute top-0 left-0  w-full h-full -z-10 bg-white
          rd-0.5em b-1 b-sand7
          hover:b-sand7
          [:checked~&]:bg-prm10
          [:checked~&]:b-prm10
        [:focus-visible~&]:outline-brand-orange [:focus-visible~&]:outline-1 [:focus-visible~&]:outline-solid
          outline-offset-2
          `}
          ></div>
        </div>
        <span className="fw-500 c-base11 capitalize input ">{label}</span>
      </label>
      {description && <p id={id + "-description"}>{description}</p>}
      <p className="min-h-2" />
    </div>
  );
});

Checkbox.displayName = "Checkbox";
export default Checkbox;
